/** Trimmed string from notification metadata, or undefined when absent/blank. */
export function notificationMetaString(
  metadata: Record<string, unknown> | null,
  key: string,
): string | undefined {
  const value = metadata?.[key];
  if (typeof value !== "string" || !value.trim()) {
    return undefined;
  }
  return value;
}
